"use strict";
/* globals module */
/**
 * @module calendarRsvpRoute
 * @description BaasicCalendarRsvpRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarRsvpRoute Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../../common");
;
var contracts_1 = require("../../../../core/contracts");
var CalendarRsvpRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarRsvpRoute, _super);
    function CalendarRsvpRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'calendars/{calendarId}/rsvp-details/{?searchQuery,page,rpp,sort,embed,fields,ids,invitationTypeIds,invitationOnly,statusIds,typeIds,registrationCloseFrom,registrationCloseTo,from,to}';
        _this.getRoute = 'calendars/{calendarId}/rsvp-details/{id}';
        _this.linkRoute = 'calendars/{calendarId}/rsvp-details';
        _this.updateRoute = 'calendars/{calendarId}/rsvp-details/{id}';
        _this.unlinkRoute = 'calendars/{calendarId}/rsvp-details/{id}';
        _this.purgeRoute = 'calendars/{calendarId}/rsvp-details/{id}/purge';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional GetCalendarOptions. Supported items are:
     * - `searchQuery` - A string referencing CalendarEventRsvp properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain CalendarEventRsvp subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the CalendarEventRsvp property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `ids` - CalendarRsvp ids which uniquely identify CalendarRsvp resources that need to be retrieved.
     * - `invitationTypeIds` - InvatationType ids which uniquely identify CalendarEventRsvpInvitationType resources used for filtering.
     * - `invitationOnly` - A value used to filter events which are invitation-only.
     * - `statusIds` - CalendarEventStatus ids which uniquely identify CalendarEventStatus resources used for filtering.
     * - `typeIds` - CalendarEventType ids which uniquely identify CalendarEventType resources used for filtering.
     * - `from` - Fluent syntax for 'From' date. Used to limit the dataset to only use resources starting from this date
     * - `to` - Fluent syntax for 'To' date. Used to limit the dataset to only use resources ending to this date.
     * - `registrationCloseFrom` - A value used to filter eventRsvps where registration is open from this date.
     * - `registrationCloseTo` - A value used to filter eventRsvps where registration is closed to this date,
     * @method
     * @param calendarId calendarId which uniquely identifies Calendar resource.
     * @param options Query resource GetCalendarOptions object.
     * @example calendarRsvpRoute.find({searchQuery: '<search-phrase>'});
     */
    CalendarRsvpRoute.prototype.find = function (calendarId, options) {
        var opt;
        if (options) {
            opt = options;
            opt.to = this.getToDate(opt);
            opt.from = this.getFromDate(opt);
            opt.registrationCloseFrom = this.getRegistrationCloseFromDate(opt);
            opt.registrationCloseTo = this.getRegistrationCloseToDate(opt);
        }
        else {
            opt = {};
        }
        var params = this.modelMapper.findParams(opt);
        params.calendarId = calendarId;
        return _super.prototype.baseFind.call(this, this.findRoute, params);
    };
    /**
     * Parses get route which must be expanded with the id of the previously created CalendarEventRsvp resource. This route can be expanded using additional GetRequestOptions. Supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id CalendarEventRsvp id which uniquely identifies CalendarEventRsvp resource that needs to be retrieved.
     * @param options Query resource options object.
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @example calendarRsvpRoute.get(id, options);
     */
    CalendarRsvpRoute.prototype.get = function (calendarId, id, options) {
        var params = this.modelMapper.getParams(options);
        params.calendarId = calendarId;
        return _super.prototype.baseGet.call(this, this.getRoute, id, params);
    };
    /**
     * Parses link route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventRsvp object that needs to be inserted into the system.
     * @param calendarId Calendar Id which uniquely identifies Calendar resource.
     * @example calendarRsvpRoute.link(data);
     */
    CalendarRsvpRoute.prototype.link = function (calendarId, data) {
        var params = this.utility.extend({}, data);
        params.calendarId = calendarId;
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventRsvp object used to update specified CalendarEventRsvp resource.
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @example calendarRsvpRoute.update(data);
     */
    CalendarRsvpRoute.prototype.update = function (calendarId, data) {
        var params = this.utility.extend({}, data);
        params.calendarId = calendarId;
        return _super.prototype.baseUpdate.call(this, this.updateRoute, params);
    };
    /**
     * Parses unlink route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEvent object used to unlink specified CalendarEvent resource.
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @example calendarRsvpRoute.unlink(data);
     */
    CalendarRsvpRoute.prototype.unlink = function (calendarId, data) {
        var params = this.utility.extend({}, data);
        params.calendarId = calendarId;
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, params);
    };
    /**
     * Parses purge route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEvent object that will have its rsvp's purged
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @example calendarRsvpRoute.purge(data);
     */
    CalendarRsvpRoute.prototype.purge = function (calendarId, data) {
        var params = this.utility.extend({}, data);
        params.calendarId = calendarId;
        return _super.prototype.baseDelete.call(this, this.purgeRoute, params);
    };
    CalendarRsvpRoute.prototype.getToDate = function (options) {
        if (!this.utility.isUndefined(options.to) && options.to !== null) {
            return options.to.toISOString();
        }
        return undefined;
    };
    CalendarRsvpRoute.prototype.getFromDate = function (options) {
        if (!this.utility.isUndefined(options.from) && options.from !== null) {
            return options.from.toISOString();
        }
        return undefined;
    };
    CalendarRsvpRoute.prototype.getRegistrationCloseFromDate = function (options) {
        if (!this.utility.isUndefined(options.registrationCloseFrom) && options.registrationCloseFrom !== null) {
            return options.registrationCloseFrom.toISOString();
        }
        return undefined;
    };
    CalendarRsvpRoute.prototype.getRegistrationCloseToDate = function (options) {
        if (!this.utility.isUndefined(options.registrationCloseTo) && options.registrationCloseTo !== null) {
            return options.registrationCloseTo.toISOString();
        }
        return undefined;
    };
    var _a;
    CalendarRsvpRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarRsvpRoute);
    return CalendarRsvpRoute;
}(common_1.BaseRoute));
exports.CalendarRsvpRoute = CalendarRsvpRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
